import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageToggle from './LanguageToggle';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  const navLinks = [
    { path: '/', label: t('nav.top') },
    { path: '/lyrics', label: t('nav.lyrics') },
    { path: '/liner-notes', label: t('nav.linerNotes') },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-300/40'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className={`font-heading text-lg font-black whitespace-nowrap transition-colors duration-300 ${
            scrolled ? 'text-foreground-950' : 'text-foreground-900'
          }`}
        >
          Who is the machine?
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm tracking-wider whitespace-nowrap transition-colors duration-300 ${
                scrolled
                  ? isActive(link.path)
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-400'
                  : isActive(link.path)
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-400'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <LanguageToggle />
        </div>

        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center transition-colors duration-300 ${
            scrolled ? 'text-foreground-950' : 'text-foreground-900'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={t('nav.menu')}
        >
          <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-300/40">
          <div className="px-4 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`text-sm tracking-wider whitespace-nowrap ${
                  isActive(link.path)
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-400'
                }`}
              >
                {link.label}
              </Link>
            ))}
            {/* 切り替えたらメニューを閉じる（言語が変わったことが背後の画面で見えるように） */}
            <LanguageToggle onChange={() => setMobileOpen(false)} />
          </div>
        </div>
      )}
    </nav>
  );
}